<template>
  <a :class="cssClass" :href="href" @click="$emit('click')">
    <slot></slot>
  </a>
</template>

<script>
  export default {
    props: {
      type: String,
      href: String
    },

    computed: {
      cssClass: function() {
        return `btn ${this.type}`
      }
    }
  }
</script>

<style lang="scss">
  @import "../assets/scss/variables";

  .primary {
    background-color: $blue;
    color: $white;

    &:hover {
      color: $white;
      background-color: darken($blue, 10%);
    }
  }

  .clear {
    color: $gray-text;
    border: 1px solid $gray-text;
  }
</style>
